import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import { TeamField } from '@modules/team/team-field';
import ImagesField from '@shared/fields/images-field';

function label(name) {
  return i18n(`entities.fan.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    "required": true
  }),
  lastName: new StringField('lastName', label('lastName'), {
    "required": true
  }),
  picture: new ImagesField('picture', label('picture'), 'fan/picture',{
    "size": 3000000,
    "max": 1
  }),
  uid: new StringField('uid', label('uid'), {
    "required": true
  }),
  teams: TeamField.relationToMany('teams', label('teams'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),

};

export class FanModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
